<div
    #templatesContainer
    class="ql-templates-list-container"
    style="display: none"
    sbClickOutside
    (sbClickOutside)="hideTemplatesList()">
    <div class="ql-templates-list" #templatesList>
        @for (template of filteredTemplates; let index = $index; track template) {
            <button
                class="dropdown-item"
                [ngClass]="{ 'group-name': template.isGroupName, selected: template.isSelected }"
                (mouseenter)="!template.isGroupName && onItemMouseEnter(index)"
                (click)="!template.isGroupName && chooseTemplate($event, template, index)">
                @if (template.isGroupName) {
                    <span class="text-light">{{ template.name }}</span>
                } @else {
                    <div class="d-flex align-items-center justify-content-between pointer w-100">
                        <div class="d-flex">
                            @if (template.children?.length || template.replyTemplates?.length) {
                                <sb-inline-svg class="icon me-1" [url]="'/sb-tools/theme/images/folder-icon.svg'">
                                </sb-inline-svg>
                            } @else {
                                <sb-inline-svg
                                    class="icon me-1"
                                    style="padding: 2px"
                                    [url]="'/sb-tools/theme/images/icons/text-icon.svg'">
                                </sb-inline-svg>
                            }

                            <span class="truncate template-name">{{ template.name }}</span>
                        </div>

                        @if (template.children?.length || template.replyTemplates?.length) {
                            <i class="triangle"></i>
                        }
                    </div>
                }
            </button>
        }
    </div>
</div>
